// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".blog-list[data-v-768d1579]{background:#f4f7fb}", "",{"version":3,"sources":["webpack://./resources/js/Pages/Blog/Index.vue"],"names":[],"mappings":"AAGA,4BACE,kBAoPF","sourcesContent":["\n@import '~/_variables.scss';\n\n.blog-list {\n  background: $ground-tint;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
